const getConstants = () => {
	return {
		base_url: 'https://api.phihomeindonesia.com/api',
		crypto_key: 'AIzaSyANWbkTvHHosHCVOad_EukhcxDbKPt0oDg',
	};
};

const constants = getConstants();

export { constants };